<template>
    <div>
        <section class="section">
            <div class="container">
                <section class="section is-medium">
                    <h1 class="titles-white is-capitalized is-size-1 is-size-4-mobile">¡disfruta de nuestra <br> programación en vivo!</h1>
                </section>
                <div class="columns is-gapless upper-panel">
                    <div class="column is-3">
                        <div class="section">
                            <h1 class="titles-white is-capitalized is-size-1 is-size-4-mobile">en vivo</h1>
                            <br>
                            <p class="is-size-5 cover-text is-size-6-mobile">
                                Lorem ipsum dolor sit amet,
                                consectetuer adipiscing elit,
                                sed diam nonummy nibh
                                euismod tincidunt ut laoreet
                                dolore magna aliquam erat
                                volutpat. Ut wisi enim ad
                                minim veniam, quis nostrud
                                exerci tation ullamcorper
                                suscipit lobortis nisl ut aliquip
                                ex ea commodo consequat.
                                Duis autem vel eum iriure
                                dolor in hendrerit in vulputate
                                velit esse molestie consequat,
                                vel illum dolore eu feugiat
                            </p>
                        </div>
                    </div>
                    <div class="column video-panel">
                        <section class="section">
                            <div class="container">
                                <iframe class="video" src="https://www.youtube.com/embed/k7h3P0of3IY" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </section>
        <section class="section is-medium bg-white">
            <div class="container">
                <h1 class="titles-secondary is-capitalized is-size-1 is-size-4-mobile">todos nuestros videos</h1>
            </div>
            <section class="section">
                <div class="container">
                    <div class="columns is-desktop is-multiline">
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                        <div class="column is-4">
                            <VideoCard></VideoCard>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import VideoCard from '@/components/VideoCard.vue'
import axios from 'axios'

export default {
    name: 'Videos',
    components: {
        VideoCard
    },
    data() {
        return {
            videos: [],
            //https://www.log2e.com/2019/02/create-a-simple-youtube-search-app-with-vue-js/
            api: {
                baseUrl: 'https://www.googleapis.com/youtube/v3/videos',
                part: 'snippet',
                type: 'video',
                maxResults: 10,
                key: '',
            }
        }
    },
    methods: {
        getData() {
            axios.get(apiURL).then(res => {
                this.videos = res.data.items
            })
            .catch(error => console.error(error))
        }
    },
    mounted() {
        //this.getData()
    }
}
</script>

<style lang="scss" scoped>
    .video {
        height: 28rem;
        width: 100%;
    }
</style>